/**
 * Created by Ivan on 11.06.2026
 */

const SeasonPassTutorial = function () {
    return new TutorialScenario(SeasonPassTutorial.NAME, {
        manual: true,
        listSteps: SeasonPassTutorial.listSteps,
        isAvailable: function () {
            return !cleverapps.forces.isShown(Forces.SEASON_PASS);
        }
    });
};

SeasonPassTutorial.listSteps = function () {
    const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_SEASON_PASS);
    const period = mission.logic.period;
    const dialogue = bundles[`season_pass_${period}_config`].jsons[`season_pass_${period}_dialogue_json`].getJson();

    return [
        cleverapps.config.type === "merge2" && SeasonPassTutorial.createSwitchModStep(),
        SeasonPassTutorial.createCloseStartWindowStep(),
        SeasonPassTutorial.createDialogueStep(dialogue),
        SeasonPassTutorial.createPointsForceStep(mission),
        SeasonPassTutorial.createVipForceStep()
    ].filter(Boolean);
};

SeasonPassTutorial.createSwitchModStep = function () {
    return new TutorialStep({
        onStart: function () {
            if (Merge2.current.mode === Merge2.MODE_GAME) {
                Merge2.current.changeMode(Merge2.MODE_META, () => {});
            }
            this.finish();
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonPassTutorial.createCloseStartWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            cleverapps.focusManager.setEventNodes([window]);

            cleverapps.tutorial.on("season_pass_start_closed", () => {
                cleverapps.focusManager.setEventNodes([]);
                this.finish();
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonPassTutorial.createDialogueStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            const dialogue = new Dialogue(data, {
                autoClose: true,
                autoScroll: 3,
                showUp: true
            });

            dialogue.on("afterClose", () => {
                this.finish();
            });

            new DialogueView(dialogue);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonPassTutorial.createPointsForceStep = function (mission) {
    return new TutorialStep({
        onStart: function () {
            cleverapps.tutorial.on("window_shown", () => {
                const window = cleverapps.focusManager.currentWindow();

                this.force = cleverapps.forces.create(ForceView.NO_ELEMENT, Forces.SEASON_PASS, {
                    highlights: [window],
                    onSkip: () => cleverapps.tutorial.skip()
                });

                if (!this.force) {
                    this.finish();
                    return;
                }

                cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
            }, this);

            cleverapps.focusManager.display({
                stack: true,
                focus: `${mission.name}Window`,
                action: function (f) {
                    const ViewConstructor = mission.view;
                    new ViewConstructor(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

SeasonPassTutorial.createVipForceStep = function () {
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        const unlockButton = window && ComponentUtils.findChildByName(window, "unlockButton");
        if (!unlockButton) {
            return;
        }

        const vipSuperContainer = ComponentUtils.findChildByName(window, "vipSuperContainer");

        return cleverapps.forces.create(unlockButton, {
            text: "SeasonPass.Tutorial.Force2",
            person: "hero",
            position: MinimalDialogue.POSITIONS.CENTER
        }, {
            highlights: [vipSuperContainer],
            importantNodes: [vipSuperContainer],
            onSkip: () => cleverapps.tutorial.skip()
        });
    };

    return new TutorialStep({
        onStart: function () {
            this.force = createForce();

            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);

            cleverapps.tutorial.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
            cleverapps.focusManager.setEventNodes([cleverapps.focusManager.currentWindow()]);
        }
    });
};

SeasonPassTutorial.NAME = "season_pass_tutorial";
